function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5147 11.7017C24.7622 11.7017 23.7654 11.685 22.5244 11.685C19.4978 11.685 17.0092 9.18 17.0092 6.125V0.765C17.0092 0.343333 16.6726 0 16.2551 0H7.43938C3.32528 0 0 3.37667 0 7.515V25.4733C0 29.815 3.4837 33.3333 7.78263 33.3333H20.9105C25.0097 33.3333 28.3333 29.9783 28.3333 25.8367V12.4517C28.3333 12.0283 27.9983 11.6867 27.5792 11.6883C26.8745 11.6933 26.0296 11.7017 25.5147 11.7017Z",
  fill: "#31D484"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9738 0.944965C20.4755 0.426632 19.6055 0.783299 19.6055 1.50163V5.89663C19.6055 7.73996 21.1238 9.25663 22.9671 9.25663C24.1288 9.26997 25.7421 9.2733 27.1121 9.26997C27.8138 9.2683 28.1705 8.42997 27.6838 7.9233C25.9255 6.09496 22.7771 2.8183 20.9738 0.944965Z",
  fill: "#31D484"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4004 21.0867C12.1427 21.088 11.885 20.9952 11.6863 20.8043L9.13055 18.3463C8.73591 17.9645 8.73188 17.3448 9.12249 16.9604C9.51311 16.5747 10.1507 16.5708 10.5467 16.9513L12.3857 18.7189L16.8757 14.2919C17.2677 13.9062 17.9053 13.9023 18.2999 14.2828C18.6959 14.6645 18.6999 15.2856 18.3093 15.6687L13.1105 20.7952C12.9145 20.9887 12.6582 21.0854 12.4004 21.0867Z",
  fill: "white"
});

function SvgPaperComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperComplete);
export default __webpack_public_path__ + "static/media/paperComplete.ca866ba42b7206a0205a71b911d4a003.svg";
export { ForwardRef as ReactComponent };